import { render, staticRenderFns } from "./AscRoleDialog.vue?vue&type=template&id=27933c13&"
import script from "./AscRoleDialog.vue?vue&type=script&lang=js&"
export * from "./AscRoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports